import { render, staticRenderFns } from "./PopinHowToUse.vue?vue&type=template&id=07bfdb9c&"
import script from "./PopinHowToUse.vue?vue&type=script&lang=js&"
export * from "./PopinHowToUse.vue?vue&type=script&lang=js&"
import style0 from "./PopinHowToUse.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports